import { GetCompanyResponse } from "api/public";

export const findDataConnectionId = (
  sourceType: string,
  dataConnections: GetCompanyResponse["dataConnections"] | undefined
) => {
  if (dataConnections?.length == 0 || !dataConnections) return "";

  const connections = dataConnections.filter(
    (connection) => connection.sourceType === sourceType
  );

  return connections[0]?.id;
};
